import Repository from '../Repository';

export default {

	getAssessmentTypes() {
		var response = Repository.get('AssessmentType/GetAssessmentTypes', {});
		return response;
	}

}
